export default __webpack_public_path__ + "static/media/KNOWN_HOW.496c5d69.pdf";